import { useId } from 'react'
import { sparklinePath, formatDelta, deltaClass } from './adminUtils'
import type { AdminTrendPoint, AdminTrendDelta } from './adminTypes'

type Props = {
  value: string | number
  label: string
  series?: AdminTrendPoint[]
  delta?: AdminTrendDelta
  warn?: boolean
  onClick?: () => void
}

export default function AdminSparklineStat({ value, label, series, delta, warn, onClick }: Props) {
  const fillId = useId()
  const lastPoints = series?.slice(-14) ?? []
  const path = sparklinePath(lastPoints)

  const Tag = onClick ? 'button' : 'div'
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      className={`vc-admin-stat vc-admin-stat--trend${warn ? ' vc-admin-stat--warn' : ''}${onClick ? ' vc-admin-stat--clickable' : ''}`}
      onClick={onClick}
    >
      <div className="vc-admin-stat__top">
        <span className="vc-admin-stat__value">{value}</span>
        {delta ? (
          <span className={`vc-admin-delta ${deltaClass(delta.pct_change)}`}>
            {formatDelta(delta.pct_change)}
          </span>
        ) : null}
      </div>
      {path ? (
        <svg className="vc-admin-sparkline" viewBox="0 0 120 36" aria-hidden="true">
          <defs>
            <linearGradient id={fillId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="currentColor" stopOpacity="0.18" />
              <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
            </linearGradient>
          </defs>
          <path d={`${path} L 120 36 L 0 36 Z`} fill={`url(#${fillId})`} stroke="none" />
          <path d={path} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      ) : null}
      <span className="vc-admin-stat__label">{label}</span>
    </Tag>
  )
}
